export enum AccountType {
    PrintingPress = -2,     //virtual types
    PrimaryStock = -1,      //virtual types
    
    Branch = 1,
    Agent = 2,
    Distributor = 3,
    SubDistributor = 4,
    ReleaseCenter = 5
}